import { isMultiYearDuration } from '@vy/types';
import { useWatch } from 'react-hook-form';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';

export const UPLIFT_UNAVAILABLE_DESCRIPTION = 'Available on multi-year contracts (13+ months)';

/** Uplift is a contract-level feature gated on plan duration; switches gate on this. */
export function useIsUpliftAvailable(): boolean {
  const duration = useWatch<PlanInputForm, 'billingData.duration'>({ name: 'billingData.duration' });

  return isMultiYearDuration(duration ?? 0);
}
